import { render, staticRenderFns } from "./PrkSyllabusHeaderPersons.vue?vue&type=template&id=11c9a420&scoped=true&"
import script from "./PrkSyllabusHeaderPersons.vue?vue&type=script&lang=js&"
export * from "./PrkSyllabusHeaderPersons.vue?vue&type=script&lang=js&"
import style0 from "./PrkSyllabusHeaderPersons.vue?vue&type=style&index=0&id=11c9a420&scoped=true&lang=scss&"
import style1 from "./PrkSyllabusHeaderPersons.vue?vue&type=style&index=1&id=11c9a420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c9a420",
  null
  
)

export default component.exports